import script from "./interest.vue?vue&type=script&setup=true&lang=js"
export * from "./interest.vue?vue&type=script&setup=true&lang=js"

import "./interest.vue?vue&type=style&index=0&id=ac6009f4&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6009f4"]])

export default __exports__